var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isValid
    ? _c(
        "div",
        [
          _c(
            "v-list-tile",
            { staticClass: "v-list--two-line" },
            [
              _c(
                "v-list-tile-avatar",
                [_c("v-icon", [_vm._v(_vm._s(_vm.icon))])],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-tile-content",
                [
                  _c("v-list-tile-title", [
                    _c("span", { staticClass: "title" }, [
                      _vm._v("\n          " + _vm._s(_vm.title) + "\n        "),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("v-list-tile-sub-title", [
                    _vm._v("\n        " + _vm._s(_vm.description) + "\n      "),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-tile-action",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { small: "" },
                      on: { click: _vm.openLinkInNewTab },
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [_vm._v("link")]),
                      _vm._v("\n        Visit\n      "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isLast ? _c("v-divider") : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }